import React, { lazy, Suspense } from 'react';
import ProtectedRoute from '../../shared/components/ProtectedRoute';
import LoadingSpinner from '../../shared/components/LoadingSpinner';

const Reports = lazy(() => import('../../routes/reports/index'));

/**
 * Reports feature routes with lazy loading
 * All report routes require authentication
 */
export const reportsRoutes = [
  {
    path: '/reports',
    element: (
      <ProtectedRoute requiredRoles={['LMS.Reporting']}>
        <Suspense fallback={<LoadingSpinner message="Loading reports..." />}>
          <Reports />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];

export default reportsRoutes;
